import { UserManager } from 'oidc-client';
import { storeUserError, storeUser } from '../actions/authActions';
import Config from '../config';

const config = Config.authConfig;

const userManager = new UserManager(config);

export function loadUserFromStorage(store) {
  // console.log('loadUserFromStorage');
  try {
    let user = userManager.getUser();
    if (!user) {
      return store.dispatch(storeUserError());
    }
    store.dispatch(storeUser(user));
  } catch (e) {
    console.error(`User not found: ${e}`);
    store.dispatch(storeUserError());
  }
}

export function signinRedirect() {
  console.log('signin-redirect');
  return userManager.signinRedirect();
}

export function signinRedirectCallback() {
  console.log('signin-redirectcallback');
  return userManager.signinRedirectCallback();
}

export function signoutRedirect() {
  console.log('signout-redirect');
  userManager.clearStaleState();
  userManager.removeUser();
  return userManager.signoutRedirect();
}

export function signoutRedirectCallback() {
  console.log('signoutRedirectCallback');
  userManager.clearStaleState();
  userManager.removeUser();
  return userManager.signoutRedirectCallback();
}

export default userManager;
